import React from 'react';

import ScrollImg1 from '../../assets/images/scroll1.png';
import ScrollImg2 from '../../assets/images/scroll2.png';
import ScrollImg3 from '../../assets/images/scroll3.png';
import ScrollImg4 from '../../assets/images/scroll4.png';
import ScrollImg6 from '../../assets/images/scroll6.png';
import ScrollImg7 from '../../assets/images/scroll7.png';

const IMAGES = [
  { src: ScrollImg1, alt: 'Academy moments' },
  { src: ScrollImg2, alt: 'Academy moments' },
  { src: ScrollImg3, alt: 'Academy moments' },
  { src: ScrollImg4, alt: 'Academy moments' },
  { src: ScrollImg6, alt: 'Academy moments' },
  { src: ScrollImg7, alt: 'Academy moments' }
];

function PictureScroll() {
  return (
    <div className="content">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {IMAGES.map((img) => (
          <div key={img.src} className="group relative rounded-2xl overflow-hidden shadow-md" style={{ height: '260px' }}>
            <img
              src={img.src}
              alt={img.alt}
              className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default PictureScroll;
